var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "#000000",
        version: "1.1",
        id: "Layer_1",
        viewBox: "0 0 508 508",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M480,28H144c-15.44,0-28,12.56-28,28v152h24V56c0-2.168,1.832-4,4-4h336c2.168,0,4,1.832,4,4v207.756c0,2.168-1.832,4-4,4    h-16v24h16c15.44,0,28-12.564,28-28.004V56C508,40.56,495.44,28,480,28z",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("rect", {
            attrs: { x: "128", y: "80", width: "372", height: "48" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: { d: "M252,140v56h220v-56H252z M456,180H268v-24h188V180z" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M416,204.008H12c-6.628,0-12,5.372-12,12v200c0,3.184,1.268,6.24,3.52,8.492c2.252,2.248,5.3,3.508,8.48,3.508    c0.004,0,0.012,0,0.016,0.004l44-0.064c6.628-0.008,11.992-5.388,11.984-12.016C67.992,409.308,62.62,408,56,408l-32-4.008    V228.008h380v32c0,6.628,5.372,12,12,12s12-5.372,12-12v-44C428,209.38,422.628,204.008,416,204.008z",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M464,264H64c-4.42,0-8,3.584-8,8v200c0,2.124,0.844,4.16,2.344,5.66C59.848,479.16,61.88,480,64,480    c0.004,0,0.004,0,0.008,0l400-0.48c4.416-0.008,7.992-3.588,7.992-8V272C472,267.584,468.416,264,464,264z M456,463.532l-384,0.46    V280h384V463.532z",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M464,256h-36v-36c0-6.628-5.372-12-12-12H12c-6.628,0-12,5.372-12,12v200c0,6.628,5.372,12,12,12h36v36    c0,3.188,1.268,6.24,3.52,8.492C53.768,478.74,56.82,480,60,480c0.004,0,0.008,0,0.012,0l404-0.48    c6.624-0.008,11.988-5.38,11.988-12V268C476,261.372,470.628,256,464,256z M452,456H72v-36c0-6.628-5.372-12-12-16H24V232h380v36    c0,6.628,5.372,12,12,12h36V456z",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M254,308.008c-31.98,0-58,26.02-58,58c0,31.98,26.02,58,58,58c31.98,0,58-26.02,58-58    C312,334.028,285.98,308.008,254,308.008z M254,408.008c-23.16,0-42-18.84-42-42c0-23.16,18.84-42,42-42c23.16,0,42,18.844,42,42    C296,389.168,277.16,408.008,254,408.008z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }